import React from 'react'
import { BrowserRouter, Route, Redirect } from 'react-router-dom'
import { ROUTES } from './routes'
import _ from 'lodash'

import SignIn from '../screens/SignIn'
import Admin from '../screens/Admin'
import LandingPage from '../screens/LandingPage'
import PrivacyPolicy from '../screens/PrivacyPolicy'
import TermsConditions from '../screens/TermsConditions'

const Router = (props) => (
    <BrowserRouter> 
        <div>
            <Route exact path="/">
                <LandingPage />
            </Route>
            <Route exact path={ROUTES.SIGN_IN}>
                {!_.isEmpty(props.authUser) ? <Redirect to={ROUTES.ADMIN} /> : <SignIn />}
            </Route>
            <Route path={ROUTES.ADMIN}>
                {!_.isEmpty(props.authUser) ? <Admin /> : <Redirect to={ROUTES.SIGN_IN} />}
            </Route>
            <Route path={ROUTES.PRIVACY_POLICY}>
                <PrivacyPolicy />
            </Route>
            <Route path={ROUTES.TERMS_CONDITIONS}>
                <TermsConditions />
            </Route>
        </div>
    </BrowserRouter>
) 

export default Router